/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Chip, styled } from '@mui/material';
import { shouldForwardProp } from '../util/helpers';

interface StatusChipProps extends Record<string, unknown> {
  textColor: string;
  bgColor: string;
  disableHover?: boolean;
}
const StatusChip = styled(Chip, {
  shouldForwardProp: (prop) =>
    shouldForwardProp<StatusChipProps>(['textColor', 'bgColor', 'disableHover'], prop),
})<StatusChipProps>`
  font-size: 0.75rem;
  line-height: 1rem;
  letter-spacing: 0.008rem;
  height: 1.2rem;
  text-transform: uppercase;
  
  &.MuiChip-root {
    color: ${({ textColor }) => textColor};
    background: ${({ bgColor }) => bgColor};
  }

  &.MuiChip-root:hover {
    color: ${({ textColor }) => textColor};
    background: ${({ bgColor }) => bgColor};
  }
`;

export default StatusChip;
